import styled from 'styled-components';

export const DatasetIconWrapper = styled.div`
  min-width: 100px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;

  > div {
    margin: ${({ theme }) => theme.margin.small};
  }
`;
